import { useContext } from 'react';
import { SelectContext } from '.';

function useSelectContext() {
  return useContext(SelectContext);
}

export default useSelectContext;
